import { createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createBlock as _createBlock, resolveDirective as _resolveDirective, withDirectives as _withDirectives, toDisplayString as _toDisplayString } from "vue"

const _hoisted_1 = { class: "bg-ff table-content" }
const _hoisted_2 = { class: "flex top-button-group" }
const _hoisted_3 = { class: "flex alignC" }
const _hoisted_4 = /*#__PURE__*/_createTextVNode("返回上一级")
const _hoisted_5 = {
  class: "flex",
  style: {"align-items":"center","justify-content":"center","padding":"20px 0"}
}
const _hoisted_6 = { class: "c-ff" }
const _hoisted_7 = /*#__PURE__*/_createTextVNode("取消")

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_el_button = _resolveComponent("el-button")
  const _component_el_option = _resolveComponent("el-option")
  const _component_el_select = _resolveComponent("el-select")
  const _component_el_form_item = _resolveComponent("el-form-item")
  const _component_el_input = _resolveComponent("el-input")
  const _component_el_form = _resolveComponent("el-form")
  const _directive_loading = _resolveDirective("loading")

  return (_openBlock(), _createBlock("div", _hoisted_1, [
    _createVNode("div", _hoisted_2, [
      _createVNode("div", _hoisted_3, [
        _createVNode(_component_el_button, {
          onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.$router.back(-1)))
        }, {
          default: _withCtx(() => [
            _hoisted_4
          ]),
          _: 1
        })
      ])
    ]),
    _createVNode("div", null, [
      _withDirectives(_createVNode(_component_el_form, {
        ref: "formRef",
        rules: _ctx.rules,
        model: _ctx.form,
        "label-width": "150px"
      }, {
        default: _withCtx(() => [
          _createVNode(_component_el_form_item, {
            label: "类型",
            prop: "type"
          }, {
            default: _withCtx(() => [
              _createVNode(_component_el_select, {
                style: {"width":"368px"},
                modelValue: _ctx.form.type,
                "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => (_ctx.form.type = $event)),
                placeholder: "请选择"
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_el_option, {
                    label: "PC端",
                    value: 1
                  }),
                  _createVNode(_component_el_option, {
                    label: "手机端",
                    value: 2
                  })
                ]),
                _: 1
              }, 8, ["modelValue"])
            ]),
            _: 1
          }),
          _createVNode(_component_el_form_item, {
            label: "上级菜单",
            prop: "parent_id",
            rules: [{ required: true, message: '请选择上级菜单' }]
          }, {
            default: _withCtx(() => [
              _createVNode(_component_el_select, {
                style: {"width":"368px"},
                modelValue: _ctx.form.parent_id,
                "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => (_ctx.form.parent_id = $event)),
                placeholder: "请选择"
              }, {
                default: _withCtx(() => [
                  (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.menuList, (item) => {
                    return (_openBlock(), _createBlock(_component_el_option, {
                      key: item.id,
                      label: item.name,
                      value: item.id
                    }, null, 8, ["label", "value"]))
                  }), 128))
                ]),
                _: 1
              }, 8, ["modelValue"])
            ]),
            _: 1
          }),
          _createVNode(_component_el_form_item, {
            label: "菜单名称",
            prop: "name"
          }, {
            default: _withCtx(() => [
              _createVNode(_component_el_input, {
                style: {"width":"368px"},
                modelValue: _ctx.form.name,
                "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => (_ctx.form.name = $event))
              }, null, 8, ["modelValue"])
            ]),
            _: 1
          }),
          _createVNode(_component_el_form_item, {
            label: "url",
            prop: "url"
          }, {
            default: _withCtx(() => [
              _createVNode(_component_el_input, {
                style: {"width":"368px"},
                modelValue: _ctx.form.url,
                "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => (_ctx.form.url = $event))
              }, null, 8, ["modelValue"])
            ]),
            _: 1
          }),
          _createVNode(_component_el_form_item, {
            label: "路由名称",
            prop: "router_name"
          }, {
            default: _withCtx(() => [
              _createVNode(_component_el_input, {
                style: {"width":"368px"},
                modelValue: _ctx.form.router_name,
                "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => (_ctx.form.router_name = $event))
              }, null, 8, ["modelValue"])
            ]),
            _: 1
          }),
          _createVNode(_component_el_form_item, {
            label: "path",
            prop: "path"
          }, {
            default: _withCtx(() => [
              _createVNode(_component_el_input, {
                style: {"width":"368px"},
                modelValue: _ctx.form.path,
                "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => (_ctx.form.path = $event))
              }, null, 8, ["modelValue"])
            ]),
            _: 1
          }),
          _createVNode(_component_el_form_item, {
            label: "组键",
            prop: "components"
          }, {
            default: _withCtx(() => [
              _createVNode(_component_el_input, {
                style: {"width":"368px"},
                modelValue: _ctx.form.components,
                "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => (_ctx.form.components = $event))
              }, null, 8, ["modelValue"])
            ]),
            _: 1
          }),
          _createVNode(_component_el_form_item, {
            label: "重定向",
            prop: "redirect"
          }, {
            default: _withCtx(() => [
              _createVNode(_component_el_input, {
                style: {"width":"368px"},
                modelValue: _ctx.form.redirect,
                "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event: any) => (_ctx.form.redirect = $event))
              }, null, 8, ["modelValue"])
            ]),
            _: 1
          }),
          _createVNode(_component_el_form_item, {
            label: "排序",
            prop: "weight"
          }, {
            default: _withCtx(() => [
              _createVNode(_component_el_input, {
                style: {"width":"368px"},
                modelValue: _ctx.form.weight,
                "onUpdate:modelValue": _cache[10] || (_cache[10] = ($event: any) => (_ctx.form.weight = $event))
              }, null, 8, ["modelValue"])
            ]),
            _: 1
          }),
          _createVNode(_component_el_form_item, {
            label: "是否显示",
            prop: "isshow"
          }, {
            default: _withCtx(() => [
              _createVNode(_component_el_select, {
                style: {"width":"368px"},
                modelValue: _ctx.form.isshow,
                "onUpdate:modelValue": _cache[11] || (_cache[11] = ($event: any) => (_ctx.form.isshow = $event)),
                placeholder: "请选择"
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_el_option, {
                    label: "不显示",
                    value: 0
                  }),
                  _createVNode(_component_el_option, {
                    label: "显示",
                    value: 1
                  })
                ]),
                _: 1
              }, 8, ["modelValue"])
            ]),
            _: 1
          }),
          _createVNode(_component_el_form_item, {
            label: "是否管理员可见",
            prop: "is_admin"
          }, {
            default: _withCtx(() => [
              _createVNode(_component_el_select, {
                style: {"width":"368px"},
                modelValue: _ctx.form.is_admin,
                "onUpdate:modelValue": _cache[12] || (_cache[12] = ($event: any) => (_ctx.form.is_admin = $event)),
                placeholder: "请选择"
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_el_option, {
                    label: "否",
                    value: 0
                  }),
                  _createVNode(_component_el_option, {
                    label: "是",
                    value: 1
                  })
                ]),
                _: 1
              }, 8, ["modelValue"])
            ]),
            _: 1
          })
        ]),
        _: 1
      }, 8, ["rules", "model"]), [
        [_directive_loading, _ctx.loading]
      ]),
      _createVNode("div", _hoisted_5, [
        _createVNode(_component_el_button, {
          class: "bg-red",
          onClick: _ctx.onSubmit
        }, {
          default: _withCtx(() => [
            _createVNode("span", _hoisted_6, _toDisplayString(_ctx.$route.query.id ? "保存" : "确定"), 1)
          ]),
          _: 1
        }, 8, ["onClick"]),
        _createVNode(_component_el_button, {
          onClick: _cache[13] || (_cache[13] = ($event: any) => (_ctx.$router.back(-1)))
        }, {
          default: _withCtx(() => [
            _hoisted_7
          ]),
          _: 1
        })
      ])
    ])
  ]))
}